import React, { useState, useEffect } from 'react';
import { Link, Switch, Route, useLocation, useRouteMatch, useHistory, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { css, StyleSheet } from 'aphrodite/no-important';
import AboutCompany from './about-company';
import { BASE_URL, DRAWER_BREAK_POINT } from '../../utils';
import { gray, blue, salmon, theme } from '../../theme';

const NoView = (
  <div className='mt-2' style={{ textAlign: 'center', animation: 'pulse-white 2s infinite' }}>
    <i
      className='fa fa-times-circle-o'
      style={{
        fontSize: '128px',
        color: salmon[500]
      }}
    />
    <div style={{ fontSize: '32px' }}>
      You do not have permission to view
    </div>
  </div>
);

const noAccessIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="19"
    fill="none"
  >
    <path
      fill="#96C8FF"
      fillRule="evenodd"
      d="m3.281 3.55-2.28-2.28L2.27 0l17.738 17.73L18.74 19l-2.932-2.92-.42-.42c-1.35.54-2.831.84-4.382.84C6.003 16.5 1.731 13.39 0 9c.78-1.98 2.081-3.7 3.742-4.99l-.46-.46ZM16.007 9c0-2.76-2.24-5-5.002-5-.65 0-1.26.13-1.83.36L7.012 2.2c1.24-.45 2.581-.7 3.982-.7C15.997 1.5 20.269 4.61 22 9c-.73 1.86-1.92 3.49-3.432 4.75l-2.92-2.92c.23-.57.36-1.18.36-1.83ZM6.533 6.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.341 3 3.002 3 .22 0 .44-.03.65-.08l1.551 1.55c-.67.33-1.41.53-2.201.53a5.003 5.003 0 0 1-5.002-5c0-.79.2-1.53.53-2.2Zm7.463 2.37-3.151-3.15.17-.01c1.66 0 3.001 1.34 3.001 3l-.02.16Z"
      clipRule="evenodd"
    />
  </svg>
);

const readOnlyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="15"
    fill="none"
  >
    <path
      fill="#96C8FF"
      fillRule="evenodd"
      d="M10 0C5.455 0 1.573 3.11 0 7.5 1.573 11.89 5.455 15 10 15c4.546 0 8.427-3.11 10-7.5C18.427 3.11 14.546 0 10 0Zm0 12.5c-2.51 0-4.545-2.24-4.545-5s2.036-5 4.545-5c2.51 0 4.546 2.24 4.546 5s-2.037 5-4.546 5Zm-2.727-5c0-1.66 1.218-3 2.727-3 1.51 0 2.727 1.34 2.727 3s-1.218 3-2.727 3c-1.51 0-2.727-1.34-2.727-3Z"
      clipRule="evenodd"
    />
  </svg>
);

const readWriteIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
  >
    <path
      fill="#96C8FF"
      fillRule="evenodd"
      d="M17.707 2.632c.39.39.39 1.02 0 1.41l-1.83 1.83-3.749-3.75 1.83-1.83a.996.996 0 0 1 1.41 0l2.34 2.34ZM0 18v-3.75L11.059 3.193l3.749 3.75L3.749 18H0Z"
      clipRule="evenodd"
    />
  </svg>
);

const drawerWidth = window.innerWidth <= DRAWER_BREAK_POINT ? window.innerWidth : 320;
const NAVBAR_HEIGHT = 73;

const CompanyDashboard = (props) => {
  const [isMobileLayout, setMobileLayout] = useState(false);
  const [isDrawerOpen, toggleDrawer] = useState(true);
  const [activeCompany, setActiveCompany] = useState({});
  const [profileAccess, setProfileAccess] = useState({
    profile: 4,
    caseLedger: 4,
    paymentsLedger: 4,
    credentialing: 4,
    insurance: 4,
    providers: 4,
    collaborators: 4,
    accessManager: 4
  });

  const location = useLocation();
  const history = useHistory();
  const { pathname } = location;
  const { path, url } = useRouteMatch();
  const { companyId } = useParams();

  // Split panel theme
  const {
    drawerBorderColor,
    // Drawer Tabs
    tabBackground,
    tabActiveBackground,
    tabHoverBackground,
    tabIndicatorBackground,
    tabIndicatorHoverBackground,
    tabIndicatorActiveBackground,
    tabTextColor,
    tabHoverTextColor,
    tabActiveTextColor,
    headerBackground,
    headerTextColor,
    groupTabIndent
  } = theme.splitPanelDrawer;

  const loadCompanyData = () => {
    const reqHeaders = new Headers();
    const token = localStorage.getItem('token');
    reqHeaders.append('Authorization', `Bearer ${token}`);
    reqHeaders.append('Content-Type', 'application/x-www-form-urlencoded');

    const requestOptions = {
      method: 'GET',
      headers: reqHeaders,
      redirect: 'follow'
    };

    const url = new URL(`${BASE_URL}/company/company`);
    const params = { id: companyId };
    url.search = new URLSearchParams(params).toString();

    fetch(url, requestOptions)
      .then(response => response.text())
      .then(result => {
        const reqData = JSON.parse(result);
        setProfileAccess(reqData.access)
        setActiveCompany(reqData.company);
      })
      .catch(error => console.log('error', error));
  };

  const handleWindowResize = () => {
    const isMobile = window.innerWidth <= 768;
    toggleDrawer(!isMobile);
    setMobileLayout(isMobile);
  };

  // Effects hook
  useEffect(() => {
    loadCompanyData();
  }, []);

  // Window resize event effect
  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    handleWindowResize();
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  // ------------------------------ Styles ------------------------------
  const styles = StyleSheet.create({
    dashboardHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '32px',
      padding: '0 8px',
      background: gray[500],
      color: gray[300]
    },
    dashboardHeaderIcon: {
      fontSize: '18px',
      color: salmon[500],
      cursor: 'pointer'
    },
    splitPanel: {
      display: 'flex',
      flexFlow: 'row nowrap',
      background: gray[800],
      height: 'calc(100% - 32px)',
      width: '100%',
      overflow: 'hidden',
      fontFamily: 'Lato'
    },
    drawer: {
      position: 'relative',
      height: '100%',
      transition: '0.3s',
      padding: isDrawerOpen ? '8px' : '0',
      zIndex: '1900',
      borderRight: `1px solid ${gray[700]}`,
      background: gray[800]
    },
    openDrawer: {
      left: '0',
      minWidth: `${drawerWidth}px`,
      width: `${drawerWidth}px`
    },
    hideDrawer: {
      transition: '0.3s',
      width: '0px',
      minWidth: '0px',
      left: `calc(-1 * ${drawerWidth}px)`
    },
    drawerHeader: {
      height: '40px',
      fontSize: '16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'left',
      cursor: 'pointer',
      background: headerBackground,
      color: headerTextColor,
      borderBottom: `0.5px solid ${drawerBorderColor}`,
      ':hover:not(.activeitem)': {
        background: tabHoverBackground,
        color: tabHoverTextColor
      }
    },
    drawerHeaderActive: {
      color: tabActiveTextColor,
      background: tabActiveBackground
    },
    drawerHeaderIconContainer: {
      height: '32px',
      // width: '32px',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 4px',
      cursor: 'pointer'
    },
    drawerHeaderIcon: {
      fontSize: '24px',
      cursor: 'pointer'
    },
    drawerHeaderTextContainer: {
      textAlign: 'left',
      lineHeight: '16px',
      cursor: 'pointer'
    },
    drawerHeaderText: {
      textAlign: 'center',
      fontSize: '14px',
      cursor: 'pointer',
      paddingLeft: '4px',
      fontWeight: 'bold'
    },
    drawerHeaderTextSub: {
      fontSize: '12px',
      cursor: 'pointer',
      paddingLeft: '4px'
    },
    drawerTabsContainer: {
      // height: `calc(100% - ${NAVBAR_HEIGHT + 64}px)`,
      height: 'calc(100% - 40px)',
      overflowY: 'auto'
    },
    drawerAccordian: {
      position: 'relative',
      display: 'block',
      transition: '0.5s ease',
      maxHeight: '2000px'
    },
    drawerFile: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: '4px',
      color: blue[200],
      height: '40px'
    },
    drawerMenuItem: {
      position: 'relative',
      marginTop: '1px',
      background: blue[800],
      color: tabTextColor,
      fill: tabTextColor,
      // borderLeft: `1px solid ${tabIndicatorBackground}`,
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingLeft: groupTabIndent,
      paddingRight: '8px',
      ':hover:not(.activeitem):not(.disabled)': {
        background: tabHoverBackground,
        color: tabHoverTextColor,
        fill: tabHoverTextColor,
        borderLeft: `1px solid ${tabIndicatorHoverBackground}`
      }
    },
    drawerMenuItemIcon: {
      height: '24px',
      // width: '30px',
      // minWidth: '24px',
      marginRight: '8px',
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '24px'
    },
    drawerMenuItemActive: {
      color: blue[500],
      background: blue[900]
    },
    drawerMenuItemText: {
      width: '100%',
      fontSize: '1rem',
      lineHeight: '14px'
    },
    linkStyles: {
      display: 'flex',
      alignItems: 'center',
      color: gray[300]
    },
    selectedLink: {
      color: blue[500]
    },
    menuItem: {
      position: 'relative',
      left: '-3px',
      color: gray[300]
    },
    detail: {
      // position: 'relative',
      transition: '0s',
      height: `calc(100vh - ${NAVBAR_HEIGHT}px)`,
      width: 'calc(100vw - 320px)',
      left: '0'
    },
    detailExapnd: {
      transition: '0.2s',
      left: 'calc(-1 * 320px)',
      width: '100vw'
    },
    detailHeader: {
      height: '40px',
      // background: '#001824',
      background: gray[800],
      display: 'flex',
      alignItems: 'center',
      borderBottom: '0.5px solid #082840',
      padding: '0 8px'
    }
  });

  const handleOnClickMiniUserCard = () => {
    history.push(`${url}/profile`);
    if (isMobileLayout) {
      toggleDrawer(false);
    }
  };

  const handleReloadData = () => {
    loadCompanyData();
  };

  const activeText = 'Company Profile';

  return (
    <div style={{ height: 'calc(100% - 40px)' }}>
      {/* Dashboard Header */}
      <div className={css(styles.dashboardHeader)}>
        <div>Company Profile</div>
        <div
          className={css(styles.dashboardHeaderIcon)}
          onClick={() => {
            if (props.usr.isMasterAdmin) {
              const lastBookmark = localStorage.getItem('lastBookmark') || '/admin/users';
              // history.push('/admin/users');
              history.push(lastBookmark);
              localStorage.setItem('lastBookmark', '');
            } else {
              history.push('/user/profile');
            }
          }}
        >
          <i className='fa fa-times-circle' />
        </div>
      </div>
      {/* Split Panel */}
      <div className={css(styles.splitPanel)}>
        {/* Panel Drawer */}
        <div className={css(styles.drawer, isDrawerOpen ? styles.openDrawer : styles.hideDrawer)}>
          {/* Drawer header (Mini user card) */}
          <div
            className={`noselect
            ${(pathname.endsWith('/profile') || pathname.endsWith('/profile/about') || pathname.endsWith('/profile/contact')) ? 'activeitem' : ''}
              ${css(styles.drawerMenuItem, (pathname.indexOf('/profile') > -1) && styles.drawerMenuItemActive)}`
            }
            onClick={handleOnClickMiniUserCard}
          >
            {/* Header */}
            <div className={css(styles.drawerHeaderIconContainer)}>
              {activeCompany.avatarImageUrl
                ? <img
                  src={activeCompany.avatarImageUrl}
                  alt="avatar"
                  style={{
                    width: 'auto',
                    height: '28px',
                    maxHeight: '28px',
                    borderRadius: '4px'
                  }}
                />
                : <i className={`fa fa-hospital-o ${css(styles.drawerHeaderIcon)}`} />
              }
              {/* Header text */}
              <div className={css(styles.drawerHeaderTextContainer)}>
                <div className={css(styles.drawerHeaderText)}>
                  {`${activeCompany.displayName ? activeCompany.displayName : 'N/A'}`}
                </div>
                <div className={css(styles.drawerHeaderTextSub)}>
                  {`@${activeCompany.userName ? activeCompany.userName : 'n/a'}`}
                </div>
              </div>
            </div>
            {/* Access */}
            <div className='fx fx__v-center'>
              {profileAccess.profile === 6 && readWriteIcon}
              {profileAccess.profile === 4 && readOnlyIcon}
              {profileAccess.profile === 0 && noAccessIcon}
            </div>
          </div>
          {/* Drawer tabs */}
          <div className={css(styles.drawerTabsContainer)}>
            {/* Entity Admin Privileges */}
            <div className={css(styles.drawerAccordian)}>
              {/* Collabortaors */}
              <div
                className={`
                  noselect
                  ${profileAccess.collaborators === 0 ? 'disabled' : ''}
                  ${pathname.endsWith('/collaborators') ? 'activeitem' : ''}
                  ${css(styles.drawerMenuItem, pathname.endsWith('/collaborators') &&
                  styles.drawerMenuItemActive)}`
                }
                onClick={() => {
                  if (profileAccess.collaborators !== 0) {
                    history.push(`${url}/collaborators`);
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }
                }}
              >
                <Link
                  to={`${url}/collaborators`}
                  className={`
                    ${profileAccess.collaborators === 0 ? 'disabled-link' : ''}
                    ${css(styles.linkStyles, pathname.endsWith('/collaborators') && styles.selectedLink)}`
                  }
                  onClick={() => {
                    if (profileAccess.collaborators !== 0) {
                      if (isMobileLayout) {
                        toggleDrawer(false);
                      }
                    }
                  }}
                >
                  <div className={css(styles.drawerMenuItemIcon)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
                      <path fill="#96C8FF" fillRule="evenodd" d="M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm14 8c0 2.213-1.787 4-4 4s-4-1.787-4-4 1.787-4 4-4 4 1.787 4 4ZM4 18.667c0-2.667 5.333-4.134 8-4.134s8 1.467 8 4.134V20H4v-1.333Z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className={css(styles.drawerMenuItemText)} >
                    Collaborators
                  </div>
                </Link>
                {/* Access */}
                <div className='fx fx__v-center'>
                  {profileAccess.collaborators === 6 && readWriteIcon}
                  {profileAccess.collaborators === 4 && readOnlyIcon}
                  {profileAccess.collaborators === 0 && noAccessIcon}
                </div>
              </div>
              {/* Access Manager */}
              <div
                className={`
                  noselect
                  ${profileAccess.profileAccessManager === 0 ? 'disabled' : ''}
                  ${pathname.endsWith('/access-manager') ? 'activeitem' : ''}
                  ${css(styles.drawerMenuItem, pathname.endsWith('/access-manager') &&
                  styles.drawerMenuItemActive)}`
                }
                onClick={() => {
                  if (profileAccess.profileAccessManager !== 0) {
                    history.push(`${url}/access-manager`);
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }
                }}
              >
                <Link
                  to={`${url}/access-manager`}
                  className={`
                    ${profileAccess.profileAccessManager === 0 ? 'disabled-link' : ''}
                    ${css(styles.linkStyles, pathname.endsWith('/access-manager') && styles.selectedLink)}`
                  }
                  onClick={() => {
                    if (profileAccess.profileAccessManager !== 0) {
                      if (isMobileLayout) {
                        toggleDrawer(false);
                      }
                    }
                  }}
                >
                  <div className={css(styles.drawerMenuItemIcon)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="24" fill="none">
                      <path fill="#96C8FF" fillRule="evenodd" d="M15.997 8h-1.143V5.714A5.716 5.716 0 0 0 9.141 0a5.716 5.716 0 0 0-5.713 5.714V8H2.285A2.292 2.292 0 0 0 0 10.286v11.428A2.292 2.292 0 0 0 2.285 24h13.712a2.292 2.292 0 0 0 2.285-2.286V10.286A2.292 2.292 0 0 0 15.997 8ZM9.142 18.286A2.292 2.292 0 0 1 6.857 16a2.292 2.292 0 0 1 2.285-2.286A2.292 2.292 0 0 1 11.428 16a2.292 2.292 0 0 1-2.286 2.286ZM5.712 5.764v2.24h6.856v-2.24c0-1.916-1.537-3.474-3.428-3.474-1.89 0-3.428 1.558-3.428 3.474Z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className={css(styles.drawerMenuItemText)} >
                    Access Manager
                  </div>
                </Link>
                {/* Access */}
                <div className='fx fx__v-center'>
                  {profileAccess.profileAccessManager === 6 && readWriteIcon}
                  {profileAccess.profileAccessManager === 4 && readOnlyIcon}
                  {profileAccess.profileAccessManager === 0 && noAccessIcon}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Panel details */}
        <div className={css(styles.detail, !isDrawerOpen && styles.detailExapnd)}>
          <div className={css(styles.detailHeader)}>
            <div>{activeText}</div>
          </div>
          {/* Active component */}
          {/* {comp} */}
          <Switch>
            <Route exact path={`${path}`}>
              <AboutCompany
                companyData={activeCompany}
                reloadCompanyData={handleReloadData}
              />
            </Route>
            <Route path={`${path}/profile`}>
              <AboutCompany
                companyData={activeCompany}
                reloadCompanyData={handleReloadData}
              />
            </Route>
            <Route path={`${path}/collaborators`}>
              <h1>Company Collaborators Placeholder</h1>
            </Route>
            <Route path={`${path}/access-manager`}>
              <h1>Company Access Managers Placeholder</h1>
            </Route>
          </Switch>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps({ user }) {
  return { ...user };
}

export default connect(mapStateToProps, {})(CompanyDashboard);
